var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"transition":_vm.transition,"scrollable":_vm.scrollable,"persistent":_vm.persistent,"max-width":_vm.maxwidth,"fullscreen":_vm.fullscreen,"retain-focus":"","disabled":_vm.disabled},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }